export default {
  en: {
    // CashSheet
    'receipt': 'Receipt',
    'download': 'Download',
    'cashSheet': 'Cash Sheet',
    'otherInfo': 'Other Info',
    'cash-sheet-download': 'Cash Sheet Download',

    // CashSheetOther
    'other-info': 'Other Info',
    'adjusted-figures': 'Adjusted Figures',
    'reconstructed-day': 'Reconstructed Day',
    'pos-removals': 'POS Removals',
    'pos-insertions': 'POS Insertions',
    'rollover': 'Rollover',
    'adjustments': 'Adjustments',
    'weather': 'Weather',
    'comments': 'Comments',
    'store-open': 'Store Open',
    'date-time': 'Date/Time',
    'store-open-user': 'Store Open User',
    'pos-close': 'POS Close',
    'pos-close-user': 'POS Close User',
    'bdc-close': 'BDC Close',
    'bdc-close-user': 'BDC Close User',
    'weather-and-comments': 'Weather and Comments',
    'open-close': 'Open/Close',
    'business-date': 'Business Date',
    'rbd-activation-needed': 'RBD Activation Needed',
    'rbd-activations-needed': 'RBD Activations Needed',
    'rbd-activations-need-completion': 'RBD Activations Need to be Completed',

    // RbdActivationDetails
    'rbd-activation-details': 'RBD Activation Details',
    'location': 'Location',
    'date': 'Date',
    'status': 'Status',

    // CashsheetWidget
    'description': 'Description',
    'qty': 'Qty',
    'amt': 'Amt',

    // SalesWidget
    'gross-sales': 'Gross Sales',
    'forever-reading-diff': 'Forever Reading Diff',
    'overrings': 'Overrings',
    'cash-refund-cashout': 'Cash Refund/Cashout',
    'cashless-refund': 'Cashless Refund',
    'gift-card-sold': 'Gift Card Sold',
    'manual-refund-overrings': 'Manual Refund/Overrings',
    'gma-delivery-driver-tips': 'GMA Delivery Driver Tips',
    'other-receipts': 'Other Receipts',
    'taxes-fees': 'Taxes/Fees',
    'total-tax': 'Total Tax',
    'deposit-1': 'Deposit 1',
    'deposit-2': 'Deposit 2',
    'fee-1': 'Fee 1',
    'fee-2': 'Fee 2',
    'eat-in': 'Eat In',
    'mobile-eat-in-tax': 'Mobile Eat In Tax',
    'take-out': 'Take Out',
    'mobile-takeout-tax': 'Mobile Takeout Tax',
    'delivery-total-tax': 'Delivery Total Tax',
    'door-dash-tax': 'Door Dash Tax',
    'door-dash-1AD-tax': 'Door Dash 1AD Tax',
    'uber-eats-tax': 'Uber Eats Tax',
    'uber-eats-1AD-tax': 'Uber Eats 1AD Tax',
    'grub-hub-tax': 'Grub Hub Tax',
    'grub-hub-1AD-tax': 'Grub Hub 1AD Tax',
    'net-sales': 'Net Sales',
    'product-sales': 'Product Sales',
    'non-product-sales': 'Non-Product Sales',
    'sales': 'Sales',
    'net-sales-is-equal': 'Net sales is equal to gross sales minus discounts, refunds, and taxes.',
    'denotes-a-reconstructed-metric': 'denotes a reconstructed metric',
    'kraven-tax': 'Kraven Tax',
    'kraven-tax-1': 'Kraven Tax 1',
    'kraven-tax-2': 'Kraven Tax 2',
    'kraven-tax-3': 'Kraven Tax 3',
    'kraven-tax-4': 'Kraven Tax 4',
    'monchis-tax': 'Monchis Tax',
    'monchis-tax-1': 'Monchis Tax 1',
    'monchis-tax-2': 'Monchis Tax 2',
    'monchis-tax-3': 'Monchis Tax 3',
    'monchis-tax-4': 'Monchis Tax 4',
    'pedidos-ya-tax': 'PedidosYa Tax',
    'pedidos-ya-tax-1': 'PedidosYa Tax 1',
    'pedidos-ya-tax-2': 'PedidosYa Tax 2',
    'pedidos-ya-tax-3': 'PedidosYa Tax 3',
    'pedidos-ya-tax-4': 'PedidosYa Tax 4',

    // DepositWidget
    'deposit': 'Deposit',
    'cash-over-short-is-equal': 'Cash Over/Short is equal to Expected Deposit minus Expected Cash.',
    'denotes-reconstructed-metric': '# denotes a reconstructed metric',
    'projected-deposit': 'Projected Deposit',
    'foreign-currency-deposit': 'Foreign Currency Deposit',
    'deposit-crime-loss': 'Deposit Crime Loss',
    'petty-cash-reimbursement': 'Petty Cash Reimbursement',
    'actual-deposit': 'Actual Deposit',
    'cash-over-short': 'Cash Over/Short',
    'foreign-currency': 'Foreign Currency',
    'expected-cash': 'Expected Cash',
    'pos-overrings': 'POS Overrings',
    'cash-refund': 'Cash Refund',
    'gift-certificates-redeemed': 'Gift Certificates Redeemed',
    'gift-cards-redeemed': 'Gift Cards Redeemed',
    'mc-balance-redeemed': 'AC Balance Redeemed',
    'billable-sales': 'Billable Sales',
    'delivery-3rd-party-gross': 'Delivery 3rd Party Gross',
    'cashless-sales': 'Cashless Sales',
    'mobile-cashless': 'Mobile Cashless',
    'in-store-cashless': 'In-Store Cashless',
    'prior-day-cash-in-deposit': 'Prior Day Cash In Deposit',
    'cash-for-next-day-deposit': 'Cash for Next Day Deposit',
    'penny-rounding': '(+/-) Penny Order Rounding',

    // AdditionalInfoWidget
    'additional-info': 'Additional Info',
    'average-check': 'Average Check',
    'non-product-sales-amt': 'Non-Product Sales Amt',
    'eat-in-sales': 'Eat-In Sales',
    'take-out-sales': 'Take-Out Sales',
    'drive-thru-sales': 'Drive-Thru Sales',
    'breakfast-sales': 'Breakfast Sales',
    'non-taxable-sales': 'Non-Taxable Sales',
    'tax-exempt-sales': 'Tax Exempt Sales',
    'rmhc': 'RMHC',
    'rmhc-cash': 'RMHC Cash',
    'rmhc-cashless': 'RMHC Cashless',
    'net-sales-digital': 'Net Sales Digital',
    'kiosk': 'Kiosk',
    'eat-in-kiosk': 'Eat In (kiosk)',
    'take-out-kiosk': 'Take Out (kiosk)',
    'mop': 'MOP',
    'eat-in-mop': 'Eat In (MOP)',
    'take-out-mop': 'Take Out (MOP)',
    'delivery': 'Delivery',
    'doordash': 'DoorDash',
    'ubereats': 'UberEats',
    'grubhub': 'GrubHub',
    'discounts': 'Discounts',
    'tred-before': 'TRED Before',
    'tred-after': 'TRED After',
    'discount': 'Discount',
    'electronic-discount': 'Electronic Discount',
    'promo': 'Promo',
    'electronic-promo': 'Electronic Promo',
    'employee-meals': 'Employee Meals',
    'manager-meals': 'Manager Meals',
    'all-coupons': 'All Coupons',
    'coupon': 'Coupon',
    'monchis': 'Monchis',
    'monchisAmt': 'Monchis Amount',
    'monchisQty': 'Monchis Quantity',
    'pedidos-ya': 'PedidosYa',
    'pedidosYaAmt': 'PedidosYa Amount',
    'pedidosYaQty': 'PedidosYa Quantity',

    // Adyen (shared)
    'adyen-essentials': 'Adyen Essentials',
    'no-data': 'No data',
    'no-data-description': 'appearing can be a function of not having the DataPass agreements signed, or not having the reports configured correctly in ADYEN\'s portal.',
    'please-review': 'Please review',
    'adyen-reporting-essentials': 'Adyen Reporting Essentials',
    'for-details': 'for details',
    'adyen-grid-footer': 'If you are not seeing data for location(s), please verify that DataPass approval has been completed and file is in CSV format. Data will be fully updated for dates after the change.',
    'adyen-source-of-truth': 'The Adyen portal is the primary source of truth. To investigate discrepancies reported in the QSRSoft report, the appropriate next step is to verify the data directly against the Adyen portal.',
    'for-more-details': 'For more details visit',
    'adyen-settlement-delay': 'Note: Settlement data is typically 2 days behind. On weekends, this delay could extend to 4-5 days.',
    'file-pending': 'File Pending',
    'settlement-not-received': 'Settlement Not Received',
    'settlement-partially-received': 'Settlement Partially Received',
    'settlement-missing': 'Settlement Missing',
    'record-status': 'Record Status',
    'adyen-variance-summary': 'Adyen Variance Summary',
    'show-flagged': 'Show Flagged',
    'by-gross-variance': 'By Gross Variance',
    'adyen-variance-detail': 'Adyen Variance Detail',
    'adyen-payout-summary': 'Adyen Payout Summary',
    'adyen-Adjustment': 'Adyen Adjustment',
    'adjustment': 'Adjustment',
    'payout-summary': 'Payout Summary',
    'variance-detail': 'Variance Detail',
    'variance-summary': 'Variance Summary',
    'visa': 'Visa',
    'master': 'Master',
    'discover': 'Discover',
    'amex': 'Amex',
    'other': 'Other',
    'debit': 'Debit',
    'batch-number': 'Batch Number',
    'batch-number-description': 'Settlement Batch Number',

    // Deposits
    'deposit-summary-grid-name': 'Deposit Summary',
    'by-store': 'By Store',
    'deposit-code': 'Deposit Code',
    'deposit-code-description': 'Can be standard daypart codes (breakfast, day, night, etc) or custom codes as specified in C&I.',
    'petty-cash-amt': 'Petty Cash Amt',
    'petty-cash-amt-description': 'Dollars of petty cash that were reimbursed from deposits',
    'deposit-amt': 'Deposit Amt',
    'deposit-amt-description': 'Amount of Deposit',
    'deposit-details-grid-name': 'Deposit Details',
    'deposit-details-analysis': 'Deposit Details Analysis',
    'deposit-details-grid-footer': '* Highlighted rows indicate a discrepancy between the "Deposit Amt" and the "Validated Deposit" amount',
    'details': 'Detail',
    'summary': 'Summary',

    // Cashless
    'cashless-summary': 'Cashless Summary',
    'cashless-by-store': 'Cashless By Store',
    'cashless-details': 'Cashless Details',
    'mobile-cashless-grid-name': 'Mobile Cashless',
    'time': 'Time',
    'time-for-cashless-gc': 'Time for a cashless GC',
    'cashless-origin': 'Cashless Origin',
    'cashless-gc-paid-through-register-or-digital-app': 'Cashless GC paid through register or digital app (In-Store or Mobile)',
    'register-number': 'Register #',
    'which-cash-register-the-cashless-gc-was-finalized-on': 'Which Cash Register the cashless GC was finalized on',
    'type': 'Type',
    'cashless-gc-type': 'Cashless GC Type',
    'card-type': 'Card Type',
    'credit-debit-card-type': 'Credit/Debit Card Type (Visa, Mastercard, Discover, Amex, Debit)',
    'card-number': 'Card #',
    'credit-debit-card-number': 'Credit/Debit Card Number',
    'total-no-gift-card': 'Total No Gift Card',
    'total-with-gift-card': 'Total With Gift Card',
    'pos-diff-no-gift-card': 'POS Diff No Gift Card',
    'mcdonalds-balance': 'McDonalds Balance',
    'gcard': 'GCard',
    'auth-number': 'Auth #',
    'authorization-number-received-from-credit-card-processor': 'Authorization number received from Credit Card processor',
    'amount': 'Amt',
    'amount-authorized-on-the-credit-card': 'Amount authorized on the credit card',
    'sequence-number': 'Sequence #',
    'this-number-reflects-the-order-of-the-gc-by-register': 'This number reflects the order of the GC by register',
    'linked-payment': 'Linked Payment',
    'whether-the-customer-paid-for': 'Whether the customer paid for an In-Store order with their linked mobile device',
    'Summary': 'Summary',
    'Detail': 'Detail',
    'Mobile': 'Mobile',

    // Tax
    'tax-details-grid-name': 'Tax Details',
    'tax-exempt-grid-name': 'Tax Exempt',
    'tax-exempt-today-grid-name': 'Tax Exempt - Today',
    'company-number': 'Company Number',
    'company-number-description': 'Company Number',
    'cust-name': 'Cust Name',
    'customer-name-description': 'Customer Name',
    'company-name': 'Company Name',
    'company-name-description': 'Company Name',
    'company-address': 'Company Address',
    'company-address-description': 'Company Address',
    'tax-exempt-amt': 'Amt',
    'tax-exempt-amt-description': 'Tax Exempt Amt',
    'payment-type': 'Payment Type',
    'payment-type-description': 'Payment Type',
    'adjusted-description': 'One or more of the figures on the cash sheet was adjusted for the period.',
    'reconstructed-description': 'One or more of the days was reconstructed through the Cash and Inventory application at the restaurant.',
    'register-removed-description': 'A register was removed from the POS system during business hours.',
    'register-added-description': 'A register was added to the POS system during business hours.',
    'rollover-description': 'If a register lasts long enough, eventually the forever reading will "roll over" and start back at 0. If this happens we will display the rollover difference here.',
    'weather-note-description': 'A note on the weather as entered by the restaurant',
    'closing-manager-note-description': 'A note entered by the closing manager to capture any information the manager thinks is important',
    'delivery-tax-total': 'Delivery Tax Total',
    'delivery-tax-total-description': 'Sum of the Tax on Delivery orders across all vendors',
    'delivery-doordash-tax': 'Delivery DoorDash Tax',
    'delivery-doordash-tax-description': 'Total Delivery Tax for DoorDash orders',
    'delivery-doordash-1-ad-tax': 'Delivery DoorDash 1-AD Tax',
    'delivery-doordash-1-ad-tax-description': 'Total Delivery Tax for Integrated DoorDash orders',
    'delivery-doordash-tax-1': 'Delivery DoorDash Tax 1',
    'delivery-doordash-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-1': 'Delivery DoorDash 1-AD Tax 1',
    'delivery-doordash-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-tax-2': 'Delivery DoorDash Tax 2',
    'delivery-doordash-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-2': 'Delivery DoorDash 1-AD Tax 2',
    'delivery-doordash-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-tax-3': 'Delivery DoorDash Tax 3',
    'delivery-doordash-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-3': 'Delivery DoorDash 1-AD Tax 3',
    'delivery-doordash-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-tax-4': 'Delivery DoorDash Tax 4',
    'delivery-doordash-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-doordash-1-ad-tax-4': 'Delivery DoorDash 1-AD Tax 4',
    'delivery-doordash-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated DoorDash orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax': 'Delivery UberEats Tax',
    'delivery-ubereats-tax-description': 'Total Delivery Tax for UberEats orders',
    'delivery-ubereats-1-ad-tax': 'Delivery UberEats 1-AD Tax',
    'delivery-ubereats-1-ad-tax-description': 'Total Delivery Tax for Integrated UberEats orders',
    'delivery-ubereats-tax-1': 'Delivery UberEats Tax 1',
    'delivery-ubereats-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-1': 'Delivery UberEats 1-AD Tax 1',
    'delivery-ubereats-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax-2': 'Delivery UberEats Tax 2',
    'delivery-ubereats-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-2': 'Delivery UberEats 1-AD Tax 2',
    'delivery-ubereats-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax-3': 'Delivery UberEats Tax 3',
    'delivery-ubereats-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-3': 'Delivery UberEats 1-AD Tax 3',
    'delivery-ubereats-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-tax-4': 'Delivery UberEats Tax 4',
    'delivery-ubereats-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-ubereats-1-ad-tax-4': 'Delivery UberEats 1-AD Tax 4',
    'delivery-ubereats-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated UberEats orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax': 'Delivery GrubHub Tax',
    'delivery-grubhub-tax-description': 'Total Delivery Tax for GrubHub orders',
    'delivery-grubhub-1-ad-tax': 'Delivery GrubHub 1-AD Tax',
    'delivery-grubhub-1-ad-tax-description': 'Total Delivery Tax for Integrated GrubHub orders',
    'delivery-grubhub-tax-1': 'Delivery GrubHub Tax 1',
    'delivery-grubhub-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-1': 'Delivery GrubHub 1-AD Tax 1',
    'delivery-grubhub-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax-2': 'Delivery GrubHub Tax 2',
    'delivery-grubhub-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-2': 'Delivery GrubHub 1-AD Tax 2',
    'delivery-grubhub-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax-3': 'Delivery GrubHub Tax 3',
    'delivery-grubhub-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-3': 'Delivery GrubHub 1-AD Tax 3',
    'delivery-grubhub-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-tax-4': 'Delivery GrubHub Tax 4',
    'delivery-grubhub-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-grubhub-1-ad-tax-4': 'Delivery GrubHub 1-AD Tax 4',
    'delivery-grubhub-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated GrubHub orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax': 'Delivery PostMates Tax',
    'delivery-postmates-tax-description': 'Total Delivery Tax for PostMates orders',
    'delivery-postmates-1-ad-tax': 'Delivery PostMates 1-AD Tax',
    'delivery-postmates-1-ad-tax-description': 'Total Delivery Tax for Integrated PostMates orders',
    'delivery-postmates-tax-1': 'Delivery PostMates Tax 1',
    'delivery-postmates-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-1': 'Delivery PostMates 1-AD Tax 1',
    'delivery-postmates-1-ad-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax-2': 'Delivery PostMates Tax 2',
    'delivery-postmates-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-2': 'Delivery PostMates 1-AD Tax 2',
    'delivery-postmates-1-ad-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax-3': 'Delivery PostMates Tax 3',
    'delivery-postmates-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-3': 'Delivery PostMates 1-AD Tax 3',
    'delivery-postmates-1-ad-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-tax-4': 'Delivery PostMates Tax 4',
    'delivery-postmates-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'delivery-postmates-1-ad-tax-4': 'Delivery PostMates 1-AD Tax 4',
    'delivery-postmates-1-ad-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Integrated PostMates orders. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-1': 'Mobile Eat In Tax 1',
    'mobile-eat-in-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-2': 'Mobile Eat In Tax 2',
    'mobile-eat-in-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-3': 'Mobile Eat In Tax 3',
    'mobile-eat-in-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-4': 'Mobile Eat In Tax 4',
    'mobile-eat-in-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Mobile orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-eat-in-tax-total': 'Mobile Eat In Tax Total',
    'mobile-eat-in-tax-total-description': 'Tax on Mobile orders that are consumed at the restaurant',
    'mobile-takeout-tax-1': 'Mobile Takeout Tax 1',
    'mobile-takeout-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-2': 'Mobile Takeout Tax 2',
    'mobile-takeout-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-3': 'Mobile Takeout Tax 3',
    'mobile-takeout-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-4': 'Mobile Takeout Tax 4',
    'mobile-takeout-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for Mobile orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'mobile-takeout-tax-total': 'Mobile Takeout Tax Total',
    'mobile-takeout-tax-total-description': 'Tax on Mobile orders that are taken from the restaurant for consumption',
    'eat-in-tax-amt': 'Eat In Tax Amt',
    'eat-in-tax-amt-description': 'Total Tax for orders that are consumed at the restaurant',
    'eat-in-tax-1': 'Eat In Tax 1',
    'eat-in-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'eat-in-tax-2': 'Eat In Tax 2',
    'eat-in-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'eat-in-tax-3': 'Eat In Tax 3',
    'eat-in-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'eat-in-tax-4': 'Eat In Tax 4',
    'eat-in-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for orders consumed at the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-amt': 'TakeOut Tax Amt',
    'takeout-tax-amt-description': 'Total Tax for orders that are taken from the restaurant for consumption',
    'takeout-tax-1': 'TakeOut Tax 1',
    'takeout-tax-1-description': 'The amount of Tax collected under the primary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-2': 'TakeOut Tax 2',
    'takeout-tax-2-description': 'The amount of Tax collected under the secondary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-3': 'TakeOut Tax 3',
    'takeout-tax-3-description': 'The amount of Tax collected under the tertiary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'takeout-tax-4': 'TakeOut Tax 4',
    'takeout-tax-4-description': 'The amount of Tax collected under the quaternary Tax in the tax chain for orders taken from the restaurant. All restaurants will use Tax 1, some restaurants may also use Tax 2, 3 and 4',
    'fee-1-amount': 'Fee 1 Amount',
    'fee-1-amount-description': 'The POS allows for collection of Fees (separate from taxes and usually not taxed)',
    'fee-2-amount': 'Fee 2 Amount',
    'fee-2-amount-description': 'The POS allows for collection of Fees (separate from taxes and usually not taxed)',
    'deposit-1-amount': 'Deposit 1 Amount',
    'deposit-1-amount-description': 'Amount of any Deposit 1 charged to the customer for bottles',
    'deposit-2-amount': 'Deposit 2 Amount',
    'deposit-2-amount-description': 'Amount of any Deposit 2 charged to the customer for bottles',
    'deposit-amt-bottles-description': 'Total amount of any deposits charged to the customer for bottles',

    // Register Audit
    'register-audit': 'Register Audit',
    'this-report-aggregates-footnote': 'This report aggregates values based on drawers. In 24-hour restaurants, drawers can cross the End of Business Day and the values may not match back to the values on the cash sheet',
    'by-location': 'By Location',
    'by-employee': 'By Employee',
    'employee-drawer': 'Employee Drawer',
    'cashier': 'Cashier',
    'cashier-name': 'Cashier Name',
    'manager': 'Manager',
    'manager-name': 'Manager Name',
    'preparer': 'Preparer',
    'preparer-name': 'Preparer Name',
    'cash-out-time': 'Cash Out Time',
    'time-the-cash-register-drawer-was-closed': 'Time the cash register drawer was closed',
    'emp-name': 'Emp Name',
    'employee-name': 'Employee Name',
    'Register': 'Register',
    'By-Location': 'By Location',
    'By-Employee': 'By Employee',
    'Employee': 'Employee',

    // Gift Card Summary
    'gift-card-summary': 'Gift Card Summary',
    'net-qty': 'Net Qty',
    'sold-qty-redeemed-qty': 'Sold Qty - Redeemed Qty',
    'net-amt': 'Net Amt',
    'sold-dollars-redeemed-dollars': 'Sold Dollars - Redeemed Dollars',
    'sold-qty': 'Sold Qty',
    'the-quantity-of-gift-cards-activated-or-reloaded': 'The quantity of gift cards activated or reloaded',
    'sold-dollars': 'Sold Dollars',
    'the-dollar-amount-of-gift-cards-activated-or-reloaded': 'The dollar amount of gift cards activated or reloaded',
    'sold-average-check': 'Sold Average Check',
    'sold-dollars-sold-qty': 'Sold Dollars / Sold Qty',
    'redeemed-qty': 'Redeemed Qty',
    'the-quantity-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'The quantity of gift cards used to pay all or part of an order',
    'redeemed-dollars': 'Redeemed Dollars',
    'the-dollar-amount-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'The dollar amount of gift cards used to pay all or part of an order',
    'redeemed-average-check': 'Redeemed Average Check',
    'redeemed-dollars-redeemed-qty': 'Redeemed Dollars / Redeemed Qty',
    'gift-card-summary-catalog-grid-name': 'Gift Card Summary',

    // Other Receipts
    'other-receipts-grid-name': 'Other Receipts',
    'other-receipts-grid-footer': 'If the date range includes a date with an RBD, this report might not match the Cash Sheet.',
    'other-receipts-today-grid-name': 'Other Receipts - Today',
    'other-receipts-detail-grid-name': 'Other Receipts Details',

    // Billable Sales / Safe Counts
    'billable-sales-grid-name': 'Billable Sales',
    'safe-counts-grid-name': 'Safe Counts',

    // ByMenuItemSelector
    'by-menu-item': 'By Menu Item',

    // Cash Statistics (standard)
    'cash-statistics': 'Cash Statistics',
    'by-date': 'By Date',
    'cash-statistics-analysis': 'Cash Statistics Analysis',

    // Legacy camelCase keys (kept for backward compatibility with existing code)
    'drawer': 'Drawer',
    'safeCount': 'Safe Count',
    'cashOverShort': 'Cash Over/Short',
    'cashOverShortDescription': 'Cash Over/Short is equal to Expected Deposit minus Expected Cash.',
    'projectedDeposit': 'Projected Deposit',
    'foreignCurrencyDeposit': 'Foreign Currency Deposit',
    'depositCrimeLoss': 'Deposit Crime Loss',
    'pettyCashReimbursement': 'Petty Cash Reimbursement',
    'actualDeposit': 'Actual Deposit',
    'foreignCurrency': 'Foreign Currency',
    'expectedCash': 'Expected Cash',
    'posOverrings': 'POS Overrings',
    'cashRefund': 'Cash Refund',
    'giftCertificatesRedeemed': 'Gift Certificates Redeemed',
    'giftCardsRedeemed': 'Gift Cards Redeemed',
    'billableSales': 'Billable Sales',
    'delivery3rdPartyGross': 'Delivery 3rd Party Gross',
    'cashlessSales': 'Cashless Sales',
    'mobileCashless': 'Mobile Cashless',
    'inStoreCashless': 'In-Store Cashless',
    'denotesReconstructedMetric': '# denotes a reconstructed metric',
  },
  es: {
    // CashSheet
    'receipt': 'Recibo',
    'download': 'Descargar',
    'cashSheet': 'Hoja de Efectivo',
    'otherInfo': 'Otra Información',
    'cash-sheet-download': 'Descarga de Hoja de Caja',

    // CashSheetOther
    'other-info': 'Otra Información',
    'adjusted-figures': 'Figuras Ajustadas',
    'reconstructed-day': 'Día Reconstruido',
    'pos-removals': 'Remociones de Punto de Venta',
    'pos-insertions': 'Inserciones de Punto de Venta',
    'rollover': 'Traspaso',
    'adjustments': 'Ajustes',
    'weather': 'Clima',
    'comments': 'Comentarios',
    'store-open': 'Tienda Abierta',
    'date-time': 'Fecha/Hora',
    'store-open-user': 'Usuario de Tienda Abierta',
    'pos-close': 'Cierre de Punto de Venta',
    'pos-close-user': 'Usuario de Cierre de Punto de Venta',
    'bdc-close': 'Cierre de BDC',
    'bdc-close-user': 'Usuario de Cierre de BDC',
    'weather-and-comments': 'Clima y Comentarios',
    'open-close': 'Abierto/Cerrado',
    'business-date': 'Fecha de Negocio',
    'rbd-activation-needed': 'Activación RBD Necesaria',
    'rbd-activations-needed': 'Activaciones RBD Necesarias',
    'rbd-activations-need-completion': 'Las Activaciones RBD Necesitan ser Completadas',

    // RbdActivationDetails
    'rbd-activation-details': 'Detalles de Activación RBD',
    'location': 'Ubicación',
    'date': 'Fecha',
    'status': 'Estado',

    // CashsheetWidget
    'description': 'Descripción',
    'qty': 'Cantidad',
    'amt': 'Monto',

    // SalesWidget
    'gross-sales': 'Ventas Brutas',
    'forever-reading-diff': 'Diferencia de Lectura Eterna',
    'overrings': 'Anulaciones',
    'cash-refund-cashout': 'Reembolso/Retiro de Efectivo',
    'cashless-refund': 'Reembolso sin Efectivo',
    'gift-card-sold': 'Tarjeta de Regalo Vendidas',
    'manual-refund-overrings': 'Reembolso Manual/Anulaciones',
    'gma-delivery-driver-tips': 'Consejos para Conductores de Reparto de GMA',
    'other-receipts': 'Otros Recibos',
    'taxes-fees': 'Impuestos/Tarifas',
    'total-tax': 'Impuestos Total',
    'deposit-1': 'Deposito 1',
    'deposit-2': 'Deposito 2',
    'fee-1': 'Tarifa 1',
    'fee-2': 'Tarifa 2',
    'eat-in': 'Consumir Aquí',
    'mobile-eat-in-tax': 'Impuestos para Consumir Aquí Usando Movil',
    'take-out': 'Para Llevar',
    'mobile-takeout-tax': 'Impuesto Sobre Comida para Llevar a Través del Móvil',
    'delivery-total-tax': 'Entrega Impuestos Totales',
    'door-dash-tax': 'Impuestos de Door Dash',
    'door-dash-1AD-tax': 'Impuestos 1AD Door Dash',
    'uber-eats-tax': 'Impuestos de Uber Eats',
    'uber-eats-1AD-tax': 'Impuestos 1AD Uber Eats',
    'grub-hub-tax': 'Impuestos de Grubhub',
    'grub-hub-1AD-tax': 'Impuestos 1AD Grub Hub',
    'net-sales': 'Ventas Netas',
    'product-sales': 'Ventas de Productos',
    'non-product-sales': 'Ventas de Productos no Relacionados',
    'sales': 'Ventas',
    'net-sales-is-equal': 'Las ventas netas son iguales a las ventas brutas menos descuentos, reembolsos e impuestos.',
    'denotes-a-reconstructed-metric': 'denota una métrica reconstruida',
    'kraven-tax': 'Impuesto Kraven',
    'kraven-tax-1': 'Impuesto Kraven 1',
    'kraven-tax-2': 'Impuesto Kraven 2',
    'kraven-tax-3': 'Impuesto Kraven 3',
    'kraven-tax-4': 'Impuesto Kraven 4',
    'monchis-tax': 'Impuesto Monchis',
    'monchis-tax-1': 'Impuesto Monchis 1',
    'monchis-tax-2': 'Impuesto Monchis 2',
    'monchis-tax-3': 'Impuesto Monchis 3',
    'monchis-tax-4': 'Impuesto Monchis 4',
    'pedidos-ya-tax': 'Impuesto PedidosYa',
    'pedidos-ya-tax-1': 'Impuesto PedidosYa 1',
    'pedidos-ya-tax-2': 'Impuesto PedidosYa 2',
    'pedidos-ya-tax-3': 'Impuesto PedidosYa 3',
    'pedidos-ya-tax-4': 'Impuesto PedidosYa 4',

    // DepositWidget
    'deposit': 'Depósito',
    'cash-over-short-is-equal': 'Efectivo Sobrante/Faltante es igual a Depósito Esperado menos Efectivo Esperado.',
    'denotes-reconstructed-metric': '# denota una métrica reconstruida',
    'projected-deposit': 'Depósito Proyectado',
    'foreign-currency-deposit': 'Depósito de Moneda Extranjera',
    'deposit-crime-loss': 'Pérdida de Crimen de Depósito',
    'petty-cash-reimbursement': 'Reembolso de Caja Chica',
    'actual-deposit': 'Depósito Real',
    'cash-over-short': 'Efectivo Sobrante/Faltante',
    'foreign-currency': 'Moneda Extranjera',
    'expected-cash': 'Efectivo Esperado',
    'pos-overrings': 'Sobregiros POS',
    'cash-refund': 'Reembolso de Efectivo',
    'gift-certificates-redeemed': 'Certificados de Regalo Canjeados',
    'gift-cards-redeemed': 'Tarjetas de Regalo Canjeadas',
    'mc-balance-redeemed': 'Saldo AC Canjeado',
    'billable-sales': 'Ventas Facturables',
    'delivery-3rd-party-gross': 'Entrega 3ra Parte Bruto',
    'cashless-sales': 'Ventas Sin Efectivo',
    'mobile-cashless': 'Sin Efectivo Móvil',
    'in-store-cashless': 'Sin Efectivo en la Tienda',
    'prior-day-cash-in-deposit': 'Depósito de Efectivo del Día Anterior',
    'cash-for-next-day-deposit': 'Efectivo para el Depósito del Día Siguiente',
    'penny-rounding': '(+/-) Redondeo de Centavos',

    // AdditionalInfoWidget
    'additional-info': 'Información Adicional',
    'average-check': 'Cheque Promedio',
    'non-product-sales-amt': 'Monto de Ventas no Relacionadas con Productos',
    'eat-in-sales': 'Ventas Para Comer en el Local',
    'take-out-sales': 'Ventas Para Llevar',
    'drive-thru-sales': 'Ventas en el Auto',
    'breakfast-sales': 'Ventas de Desayuno',
    'non-taxable-sales': 'Ventas no Gravables',
    'tax-exempt-sales': 'Ventas Exentas de Impuestos',
    'rmhc': 'Organización Benéfica de la Casa Ronald McDonald',
    'rmhc-cash': 'Organización Benéfica de la Casa Ronald McDonald en Efectivo',
    'rmhc-cashless': 'Organización Benéfica de la Casa Ronald McDonald sin Efectivo',
    'net-sales-digital': 'Ventas Netas Digitales',
    'kiosk': 'Kiosco',
    'eat-in-kiosk': 'Comer en el Kiosco',
    'take-out-kiosk': 'Llevar en el Kiosco',
    'mop': 'MOP',
    'eat-in-mop': 'Comer en MOP',
    'take-out-mop': 'Llevar en MOP',
    'delivery': 'Entrega',
    'doordash': 'DoorDash',
    'ubereats': 'UberEats',
    'grubhub': 'GrubHub',
    'discounts': 'Descuentos',
    'tred-before': 'TRED Antes',
    'tred-after': 'TRED Después',
    'discount': 'Descuento',
    'electronic-discount': 'Descuento Electrónico',
    'promo': 'Promoción',
    'electronic-promo': 'Promoción Electrónica',
    'employee-meals': 'Comidas de Empleados',
    'manager-meals': 'Comidas de Gerentes',
    'all-coupons': 'Todos los Cupones',
    'coupon': 'Cupón',
    'monchis': 'Monchis',
    'monchisAmt': 'Monto Monchis',
    'monchisQty': 'Cantidad Monchis',
    'pedidos-ya': 'PedidosYa',
    'pedidosYaAmt': 'Monto PedidosYa',
    'pedidosYaQty': 'Cantidad PedidosYa',

    // Adyen (shared)
    'adyen-essentials': 'Adyen Esenciales',
    'no-data': 'Sin datos',
    'no-data-description': 'aparecer puede ser una función de no tener los acuerdos de DataPass firmados, o no tener los informes configurados correctamente en el portal de ADYEN.',
    'please-review': 'Por favor, revise',
    'adyen-reporting-essentials': 'Elementos Esenciales de Informes de Adyen',
    'for-details': 'para detalles',
    'adyen-grid-footer': 'Si no está viendo datos para las ubicaciones, por favor verifique que la aprobación de DataPass se haya completado y que el archivo esté en formato CSV. Los datos se actualizarán completamente para las fechas posteriores al cambio.',
    'adyen-source-of-truth': 'El portal de Adyen es la fuente principal de verdad. Para investigar discrepancias reportadas en el informe de QSRSoft, el siguiente paso apropiado es verificar los datos directamente contra el portal de Adyen.',
    'for-more-details': 'Para más detalles visite',
    'adyen-settlement-delay': 'Nota: Los datos de liquidación generalmente tienen un retraso de 2 días. Los fines de semana, este retraso podría extenderse a 4-5 días.',
    'file-pending': 'Archivo Pendiente',
    'settlement-not-received': 'Liquidación No Recibida',
    'settlement-partially-received': 'Liquidación Parcialmente Recibida',
    'settlement-missing': 'Liquidación Faltante',
    'record-status': 'Estado del Registro',
    'adyen-variance-summary': 'Resumen de Variación de Adyen',
    'show-flagged': 'Mostrar Marcados',
    'by-gross-variance': 'Por Variación Bruta',
    'adyen-variance-detail': 'Detalle de Variación de Adyen',
    'adyen-payout-summary': 'Resumen de Pagos de Adyen',
    'adyen-Adjustment': 'Ajuste de Adyen',
    'adjustment': 'Ajuste',
    'payout-summary': 'Resumen de Pagos',
    'variance-detail': 'Detalle de Varianza',
    'variance-summary': 'Resumen de Varianza',
    'visa': 'Visa',
    'master': 'Master',
    'discover': 'Discover',
    'amex': 'Amex',
    'other': 'Otro',
    'debit': 'Débito',
    'batch-number': 'Número de Lote',
    'batch-number-description': 'Número de Lote de Liquidación',

    // Deposits
    'deposit-summary-grid-name': 'Resumen de Depósitos',
    'by-store': 'Por Ubicación',
    'deposit-code': 'Código de Depósito',
    'deposit-code-description': 'Puede ser códigos estándar de parte del día (desayuno, día, noche, etc.) o códigos personalizados según lo especificado en C&I.',
    'petty-cash-amt': 'Monto de Efectivo Menor',
    'petty-cash-amt-description': 'Dólares de efectivo menor que fueron reembolsados de los depósitos',
    'deposit-amt': 'Monto del Depósito',
    'deposit-amt-description': 'Monto del Depósito',
    'deposit-details-grid-name': 'Detalles del Depósito',
    'deposit-details-analysis': 'Análisis de Detalles del Depósito',
    'deposit-details-grid-footer': '* Las filas resaltadas indican una discrepancia entre el "Monto del Depósito" y el "Depósito Validado"',
    'details': 'Detalle',
    'summary': 'Resumen',

    // Cashless
    'cashless-summary': 'Resumen sin Efectivo',
    'cashless-by-store': 'Sin Efectivo por Tienda',
    'cashless-details': 'Detalles sin Efectivo',
    'mobile-cashless-grid-name': 'Sin Efectivo Móvil',
    'time': 'Hora',
    'time-for-cashless-gc': 'Hora para una GC sin efectivo',
    'cashless-origin': 'Origen sin Efectivo',
    'cashless-gc-paid-through-register-or-digital-app': 'GC sin efectivo pagado a través de la aplicación de registro o digital (en la tienda o móvil)',
    'register-number': 'Número de Registro',
    'which-cash-register-the-cashless-gc-was-finalized-on': 'En qué caja registradora se finalizó la GC sin efectivo',
    'type': 'Tipo',
    'cashless-gc-type': 'Tipo de GC sin Efectivo',
    'card-type': 'Tipo de Tarjeta',
    'credit-debit-card-number': 'Número de Tarjeta de Crédito/Débito',
    'total-no-gift-card': 'Total Sin Tarjeta de Regalo',
    'total-with-gift-card': 'Total Con Tarjeta de Regalo',
    'pos-diff-no-gift-card': 'Dif. POS Sin Tarjeta de Regalo',
    'mcdonalds-balance': 'McDonalds Balance',
    'gcard': 'Tarjeta de Regalo',
    'credit-debit-card-type': 'Tipo de tarjeta de crédito/débito (Visa, Mastercard, Discover, Amex, Débito)',
    'card-number': 'Número de Tarjeta',
    'auth-number': 'Número de Autorización',
    'authorization-number-received-from-credit-card-processor': 'Número de autorización recibido del procesador de tarjetas de crédito',
    'amount': 'Monto',
    'amount-authorized-on-the-credit-card': 'Monto autorizado en la tarjeta de crédito',
    'sequence-number': 'Número de Secuencia',
    'this-number-reflects-the-order-of-the-gc-by-register': 'Este número refleja el orden de la GC por registro',
    'linked-payment': 'Pago Vinculado',
    'whether-the-customer-paid-for': 'Si el cliente pagó un pedido en la tienda con su dispositivo móvil vinculado',
    'Summary': 'Resumen',
    'Detail': 'Detalle',
    'Mobile': 'Móvil',

    // Tax
    'tax-details-grid-name': 'Detalles de Impuestos',
    'tax-exempt-grid-name': 'Exento de Impuestos',
    'tax-exempt-today-grid-name': 'Exento de Impuestos - Hoy',
    'company-number': 'Número de Empresa',
    'company-number-description': 'Número de Empresa',
    'cust-name': 'Nombre del Cliente',
    'customer-name-description': 'Nombre del Cliente',
    'company-name': 'Nombre de la Empresa',
    'company-name-description': 'Nombre de la Empresa',
    'company-address': 'Dirección de la Empresa',
    'company-address-description': 'Dirección de la Empresa',
    'tax-exempt-amt': 'Monto',
    'tax-exempt-amt-description': 'Monto Exento de Impuestos',
    'payment-type': 'Tipo de Pago',
    'payment-type-description': 'Tipo de Pago',
    'adjusted-description': 'Una o más cifras de la hoja de caja fueron ajustadas para el período.',
    'reconstructed-description': 'Uno o más días fueron reconstruidos mediante la aplicación de Caja e Inventario en el restaurante.',
    'register-removed-description': 'Se eliminó una caja registradora del sistema POS durante el horario comercial.',
    'register-added-description': 'Se agregó una caja registradora al sistema POS durante el horario comercial.',
    'rollover-description': 'Si una caja registradora dura suficiente tiempo, eventualmente la lectura permanente se "reiniciará" y comenzará de nuevo en 0. Si esto ocurre, mostraremos la diferencia del reinicio aquí.',
    'weather-note-description': 'Una nota sobre el clima ingresada por el restaurante',
    'closing-manager-note-description': 'Una nota ingresada por el gerente de cierre para capturar cualquier información que el gerente considere importante',
    'delivery-tax-total': 'Total de Impuesto de Entrega',
    'delivery-tax-total-description': 'Suma del Impuesto en pedidos de Entrega a través de todos los proveedores',
    'delivery-doordash-tax': 'Total de Impuesto de Entrega de DoorDash',
    'delivery-doordash-tax-description': 'Suma del Impuesto en pedidos de Entrega de DoorDash',
    'delivery-doordash-1-ad-tax': 'Total de Impuesto de Entrega de DoorDash 1-AD',
    'delivery-doordash-1-ad-tax-description': 'Suma del Impuesto en pedidos de Entrega de DoorDash 1-AD',
    'delivery-doordash-tax-1': 'Impuesto de Entrega de DoorDash 1',
    'delivery-doordash-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-1': 'Impuesto de Entrega de DoorDash 1-AD',
    'delivery-doordash-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-tax-2': 'Impuesto de Entrega de DoorDash 2',
    'delivery-doordash-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-2': 'Impuesto de Entrega de DoorDash 1-AD 2',
    'delivery-doordash-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-tax-3': 'Impuesto de Entrega de DoorDash 3',
    'delivery-doordash-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-3': 'Impuesto de Entrega de DoorDash 1-AD 3',
    'delivery-doordash-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-tax-4': 'Impuesto de Entrega de DoorDash 4',
    'delivery-doordash-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de DoorDash. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-doordash-1-ad-tax-4': 'Impuesto de Entrega de DoorDash 1-AD 4',
    'delivery-doordash-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de DoorDash 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax': 'Impuesto de Entrega de UberEats',
    'delivery-ubereats-tax-description': 'La cantidad total de Impuesto de Entrega para pedidos de UberEats',
    'delivery-ubereats-1-ad-tax': 'Impuesto de Entrega de UberEats 1-AD',
    'delivery-ubereats-1-ad-tax-description': 'La cantidad total de Impuesto de Entrega para pedidos de UberEats 1-AD',
    'delivery-ubereats-tax-1': 'Impuesto de Entrega de UberEats 1',
    'delivery-ubereats-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-1': 'Impuesto de Entrega de UberEats 1-AD',
    'delivery-ubereats-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax-2': 'Impuesto de Entrega de UberEats 2',
    'delivery-ubereats-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-2': 'Impuesto de Entrega de UberEats 1-AD 2',
    'delivery-ubereats-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax-3': 'Impuesto de Entrega de UberEats 3',
    'delivery-ubereats-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-3': 'Impuesto de Entrega de UberEats 1-AD 3',
    'delivery-ubereats-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-tax-4': 'Impuesto de Entrega de UberEats 4',
    'delivery-ubereats-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de UberEats. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-ubereats-1-ad-tax-4': 'Impuesto de Entrega de UberEats 1-AD 4',
    'delivery-ubereats-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de UberEats 1-AD. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax': 'Impuesto de Entrega de GrubHub',
    'delivery-grubhub-tax-description': 'Impuesto total de Entrega para pedidos de GrubHub',
    'delivery-grubhub-1-ad-tax': 'Impuesto de Entrega de GrubHub 1-AD',
    'delivery-grubhub-1-ad-tax-description': 'Impuesto total de Entrega para pedidos integrados de GrubHub',
    'delivery-grubhub-tax-1': 'Impuesto de Entrega de GrubHub 1',
    'delivery-grubhub-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-1': 'Impuesto de Entrega de GrubHub 1-AD 1',
    'delivery-grubhub-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax-2': 'Impuesto de Entrega de GrubHub 2',
    'delivery-grubhub-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-2': 'Impuesto de Entrega de GrubHub 1-AD 2',
    'delivery-grubhub-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax-3': 'Impuesto de Entrega de GrubHub 3',
    'delivery-grubhub-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-3': 'Impuesto de Entrega de GrubHub 1-AD 3',
    'delivery-grubhub-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-tax-4': 'Impuesto de Entrega de GrubHub 4',
    'delivery-grubhub-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-grubhub-1-ad-tax-4': 'Impuesto de Entrega de GrubHub 1-AD 4',
    'delivery-grubhub-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos integrados de GrubHub. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax': 'Impuesto de Entrega de PostMates',
    'delivery-postmates-tax-description': 'Impuesto total de Entrega para pedidos de PostMates',
    'delivery-postmates-1-ad-tax': 'Impuesto de Entrega de PostMates 1-AD',
    'delivery-postmates-1-ad-tax-description': 'Impuesto total de Entrega para pedidos integrados de PostMates',
    'delivery-postmates-tax-1': 'Impuesto de Entrega de PostMates 1',
    'delivery-postmates-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-1': 'Impuesto de Entrega de PostMates 1-AD 1',
    'delivery-postmates-1-ad-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax-2': 'Impuesto de Entrega de PostMates 2',
    'delivery-postmates-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-2': 'Impuesto de Entrega de PostMates 1-AD 2',
    'delivery-postmates-1-ad-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax-3': 'Impuesto de Entrega de PostMates 3',
    'delivery-postmates-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-3': 'Impuesto de Entrega de PostMates 1-AD 3',
    'delivery-postmates-1-ad-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-tax-4': 'Impuesto de Entrega de PostMates 4',
    'delivery-postmates-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'delivery-postmates-1-ad-tax-4': 'Impuesto de Entrega de PostMates 1-AD 4',
    'delivery-postmates-1-ad-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos integrados de PostMates. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-1': 'Impuesto Móvil para Comer Aquí 1',
    'mobile-eat-in-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-2': 'Impuesto Móvil para Comer Aquí 2',
    'mobile-eat-in-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-3': 'Impuesto Móvil para Comer Aquí 3',
    'mobile-eat-in-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-4': 'Impuesto Móvil para Comer Aquí 4',
    'mobile-eat-in-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos móviles consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-eat-in-tax-total': 'Total de Impuesto Móvil para Comer Aquí',
    'mobile-eat-in-tax-total-description': 'Impuesto sobre pedidos móviles que se consumen en el restaurante',
    'mobile-takeout-tax-1': 'Impuesto Móvil para Llevar 1',
    'mobile-takeout-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-2': 'Impuesto Móvil para Llevar 2',
    'mobile-takeout-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-3': 'Impuesto Móvil para Llevar 3',
    'mobile-takeout-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-4': 'Impuesto Móvil para Llevar 4',
    'mobile-takeout-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos móviles tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'mobile-takeout-tax-total': 'Total de Impuesto Móvil para Llevar',
    'mobile-takeout-tax-total-description': 'Impuesto sobre pedidos móviles que se toman del restaurante para consumo',
    'eat-in-tax-amt': 'Monto de Impuesto para Comer Aquí',
    'eat-in-tax-amt-description': 'Impuesto total para pedidos que se consumen en el restaurante',
    'eat-in-tax-1': 'Impuesto para Comer Aquí 1',
    'eat-in-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'eat-in-tax-2': 'Impuesto para Comer Aquí 2',
    'eat-in-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'eat-in-tax-3': 'Impuesto para Comer Aquí 3',
    'eat-in-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'eat-in-tax-4': 'Impuesto para Comer Aquí 4',
    'eat-in-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos consumidos en el restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-amt': 'Monto de Impuesto para Llevar',
    'takeout-tax-amt-description': 'Impuesto total para pedidos que se toman del restaurante para consumo',
    'takeout-tax-1': 'Impuesto para Llevar 1',
    'takeout-tax-1-description': 'La cantidad de Impuesto recaudado bajo el Impuesto primario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-2': 'Impuesto para Llevar 2',
    'takeout-tax-2-description': 'La cantidad de Impuesto recaudado bajo el Impuesto secundario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-3': 'Impuesto para Llevar 3',
    'takeout-tax-3-description': 'La cantidad de Impuesto recaudado bajo el Impuesto terciario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'takeout-tax-4': 'Impuesto para Llevar 4',
    'takeout-tax-4-description': 'La cantidad de Impuesto recaudado bajo el Impuesto cuaternario en la cadena de impuestos para pedidos tomados del restaurante. Todos los restaurantes utilizarán el Impuesto 1, algunos restaurantes también pueden utilizar los Impuestos 2, 3 y 4',
    'fee-1-amount': 'Monto de Tarifa 1',
    'fee-1-amount-description': 'El POS permite la recolección de Tarifas (separadas de impuestos y usualmente no gravadas)',
    'fee-2-amount': 'Monto de Tarifa 2',
    'fee-2-amount-description': 'El POS permite la recolección de Tarifas (separadas de impuestos y usualmente no gravadas)',
    'deposit-1-amount': 'Monto de Depósito 1',
    'deposit-1-amount-description': 'Monto de cualquier Depósito 1 cobrado al cliente por botellas',
    'deposit-2-amount': 'Monto de Depósito 2',
    'deposit-2-amount-description': 'Monto de cualquier Depósito 2 cobrado al cliente por botellas',
    'deposit-amt-bottles-description': 'Monto total de cualquier depósito cobrado al cliente por botellas',

    // Register Audit
    'register-audit': 'Auditoría de Caja',
    'this-report-aggregates-footnote': 'Este informe agrega valores en función de las cajas registradoras. En los restaurantes de 24 horas, las cajas pueden cruzar el Fin del Día Comercial y los valores pueden no coincidir con los valores de la hoja de caja',
    'by-location': 'Por Ubicación',
    'by-employee': 'Por Empleado',
    'employee-drawer': 'Cajón de Empleado',
    'cashier': 'Cajero',
    'cashier-name': 'Nombre del Cajero',
    'manager': 'Gerente',
    'manager-name': 'Nombre del Gerente',
    'preparer': 'Preparador',
    'preparer-name': 'Nombre del Preparador',
    'cash-out-time': 'Hora de Cierre',
    'time-the-cash-register-drawer-was-closed': 'Hora en que se cerró el cajón de la caja',
    'emp-name': 'Nombre del Empleado',
    'employee-name': 'Nombre del Empleado',
    'Register': 'Registro',
    'By-Location': 'Por Ubicación',
    'By-Employee': 'Por Empleado',
    'Employee': 'Empleado',

    // Gift Card Summary
    'gift-card-summary': 'Resumen de Tarjetas de Regalo',
    'net-qty': 'Cantidad Neta',
    'sold-qty-redeemed-qty': 'Cantidad vendida - Cantidad Canjeada',
    'net-amt': 'Monto Neto',
    'sold-dollars-redeemed-dollars': 'Dólares vendidos - Dólares Canjeados',
    'sold-qty': 'Cantidad Vendida',
    'the-quantity-of-gift-cards-activated-or-reloaded': 'La cantidad de tarjetas de regalo activadas o recargadas',
    'sold-dollars': 'Dólares Vendidos',
    'the-dollar-amount-of-gift-cards-activated-or-reloaded': 'La cantidad de dólares de tarjetas de regalo activadas o recargadas',
    'sold-average-check': 'Promedio de Cheque Vendido',
    'sold-dollars-sold-qty': 'Dólares Vendidos / Cantidad Vendida',
    'redeemed-qty': 'Cantidad Canjeada',
    'the-quantity-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'La cantidad de tarjetas de regalo utilizadas para pagar todo o parte de un pedido',
    'redeemed-dollars': 'Dólares Canjeados',
    'the-dollar-amount-of-gift-cards-used-to-pay-all-or-part-of-an-order': 'La cantidad de dólares de tarjetas de regalo utilizadas para pagar todo o parte de un pedido',
    'redeemed-average-check': 'Promedio de Cheque Canjeado',
    'redeemed-dollars-redeemed-qty': 'Dólares Canjeados / Cantidad Canjeada',
    'gift-card-summary-catalog-grid-name': 'Resumen de Tarjetas de Regalo',

    // Other Receipts
    'other-receipts-grid-name': 'Otros Recibos',
    'other-receipts-grid-footer': 'Si el rango de fechas incluye una fecha con un RBD, este informe puede no coincidir con el Libro de Caja.',
    'other-receipts-today-grid-name': 'Otros Recibos - Hoy',
    'other-receipts-detail-grid-name': 'Detalles de Otros Recibos',

    // Billable Sales / Safe Counts
    'billable-sales-grid-name': 'Ventas facturables',
    'safe-counts-grid-name': 'Conteos de Caja',

    // ByMenuItemSelector
    'by-menu-item': 'Por Artículo del Menú',

    // Cash Statistics (standard)
    'cash-statistics': 'Estadísticas de Efectivo',
    'by-date': 'Por Fecha',
    'cash-statistics-analysis': 'Análisis de Estadísticas de Efectivo',

    // Legacy camelCase keys (kept for backward compatibility with existing code)
    'drawer': 'Cajón',
    'safeCount': 'Conteo de Caja Fuerte',
    'cashOverShort': 'Sobrante/Faltante de Caja',
    'cashOverShortDescription': 'Sobrante/Faltante es igual al Depósito Esperado menos el Efectivo Esperado.',
    'projectedDeposit': 'Depósito Proyectado',
    'foreignCurrencyDeposit': 'Depósito de Moneda Extranjera',
    'depositCrimeLoss': 'Pérdida por Delito de Depósito',
    'pettyCashReimbursement': 'Reembolso de Caja Chica',
    'actualDeposit': 'Depósito Real',
    'foreignCurrency': 'Moneda Extranjera',
    'expectedCash': 'Efectivo Esperado',
    'posOverrings': 'Anulaciones POS',
    'cashRefund': 'Reembolso en Efectivo',
    'giftCertificatesRedeemed': 'Certificados de Regalo Canjeados',
    'giftCardsRedeemed': 'Tarjetas de Regalo Canjeadas',
    'billableSales': 'Ventas Facturables',
    'delivery3rdPartyGross': 'Entrega de Terceros Bruto',
    'cashlessSales': 'Ventas sin Efectivo',
    'mobileCashless': 'Móvil sin Efectivo',
    'inStoreCashless': 'En Tienda sin Efectivo',
    'denotesReconstructedMetric': '# denota una métrica reconstruida',
  },
};
